export default __webpack_public_path__ + "b8252de940b085bded6324b3531681bf.png";